<template>
  <div class="row align-center">
    <div class="small-11 medium-10 large-9 columns content">
      <div class="row">
        <div :key="pessoa.id"
             class="small-12 medium-6 large-4 columns"
             v-for="pessoa in pessoas">
          <pessoaDep
              :url="pessoa.url"
              :nome="pessoa.nome"
              :color="secundaryColors[$store.state.color]"
              :cargo="pessoa.cargo"
              :categoria="pessoa.categoria"
              :email="pessoa.email"
              :imagem="pessoa.image"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pessoaDep from '../components/pessoa';

export default {
  name: "pessoasDepartamento",
  components:{
    pessoaDep
  },
  inject:["secundaryColors","i18n"],
  data(){
    return{
      pessoas:[]
    }
  },
  created() {
    this.getPessoasForDepartamento();
  },
  methods:{
    getPessoasForDepartamento(){
      const url = `${process.env.VUE_APP_AXIOS}/departamento/${this.$route.params.id}/membros?idioma=${this.$store.state.language}`;
      fetch(url)
          .then(response => response.json())
          .then(data => {
            this.pessoas = data.map(el => {
              return {
                id: el.ID,
                nome: el.Pessoa.name,
                cargo: el.Tipo +" "+ this.$translate("UMA_LANG_DEPARTAMENTOS_DODEPARTAMENTO"),//this.i18n.doDepartamento,
                image: el.Pessoa.smallimage,
                url: el.Pessoa.url,
                categoria: el.Pessoa.categoria,
                email: el.Pessoa.email
              }
            })
          })
          .catch(error => console.log(error));
    }
  }
}
</script>

<style scoped>

.content .row {
  margin-left: 0px;
  margin-right: 0px;
}
.content {
  padding-right: 0px;
  padding-left: 0px;
}

.content .row .columns {
  padding-right: 3px;
  padding-left: 3px;
}

.content {
  padding-top: 60px;
  padding-bottom: 100px;
}

@media (max-width: 1250px) {
  .content {
    padding-top: 40px;
    padding-bottom: 60px;
  }
}

@media (max-width: 767px) {
  .content {
    padding-top: 20px;
  }
}

</style>